module.exports = __webpack_public_path__ + "img/31.0ff7028c.jpg";